import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/AssetStoreLogo.png'


const _hoisted_1 = {
  id: "header",
  class: "mx-auto flex max-w-xl items-center justify-between py-1.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-start gap-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "40",
    height: "auto"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-left font-bold leading-none" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("On-chain"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Asset Store")
    ])
  ])
], -1)
const _hoisted_3 = {
  id: "nav",
  class: "flex flex-wrap items-center justify-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.home")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/material'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.material")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/kamon'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.kamon")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/emoji'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.flags")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_Languages)
  ]))
}